import { Heading } from "../../../../atoms";
import { Flex } from "../../../../cores";
import { useViewContext } from "../../../../hooks";
import { IKeyStringAndValue } from "../../../../types/Types";
import EffectivityPointsDescription from "./EffectivityPointsDescription";

interface IEffectivityDescription {
  emptyFilterOptions: boolean;
  filterOptions: IKeyStringAndValue | undefined;
  descriptionTitle: string;
  descriptionText: Array<string>;
}

const EffectivityDescription = ({
  emptyFilterOptions,
  filterOptions,
  descriptionTitle,
  descriptionText,
}: IEffectivityDescription) => {
  const { isMobile } = useViewContext();
  return !emptyFilterOptions ? (
    (filterOptions as IKeyStringAndValue)["typeOfPump"] !== "fl" ? (
      <Flex
        sx={{
          order: 1,
          width: ["100%", null, "50%", "25%", "25%"],
          flexDirection: "column",
          "> div": {
            marginY: 10,
            "> p": {
              marginLeft: "sm",
              fontSize: ["xs", null, "16px", null, null],
            },
          },
        }}
      >
        <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
          {descriptionTitle}
        </Heading>
        <EffectivityPointsDescription
          valueGoodChoice={descriptionText[0]}
          valueApproved={descriptionText[1]}
        />
      </Flex>
    ) : null
  ) : null;
};

export default EffectivityDescription;
